import React from 'react';
import { RootState } from '../../store';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ISession } from '../../models/pro-sites';
import './software.css';
import * as CON from '../common/constants';
import { useSoftwareInfo } from '../../hooks/use-software-info-hook';
import {
    ISoftwareReducedInfoLinks,
    ISoftwareReducedInfo,
} from '../../models/software';
interface ISoftwarePageProps {
    session: ISession | null;
}
export const SoftwarePage: React.FC<ISoftwarePageProps> = ({ session }) => {
    const softwareInfo = useSoftwareInfo();
    const isSoftwareInfo = softwareInfo && softwareInfo.length > 0;

    const renderLinks = (links: ISoftwareReducedInfoLinks[]): JSX.Element[] => {
        return links.map((obj, index) => {
            return (
                <dl key={index}>
                    <dd>
                        <a href={obj.link}>
                            {obj.type === CON.PRO_FIT_LINK_TYPE && (
                                <FormattedMessage
                                    id="latest_pro_fit_installer"
                                    defaultMessage={
                                        'Latest Pro Fit Software Installer'
                                    }
                                />
                            )}
                            {obj.type === CON.INSPIRE_LINK_TYPE && (
                                <FormattedMessage
                                    id="latest_inspire_installer_x"
                                    defaultMessage={
                                        'Latest Inspire X Software Installer'
                                    }
                                />
                            )}
                            <br />
                            <div>
                                {links.length > 1 ? (
                                    <span>
                                        <FormattedMessage
                                            id="download_exe"
                                            defaultMessage={'Download EXE'}
                                        />{' '}
                                        {'for'} {obj.brand}
                                    </span>
                                ) : (
                                    <span>
                                        <FormattedMessage
                                            id="download_exe"
                                            defaultMessage={'Download EXE'}
                                        />
                                    </span>
                                )}
                            </div>
                        </a>
                    </dd>
                </dl>
            );
        });
    };
    const renderSoftwareInfo = (
        { links, brand, type }: ISoftwareReducedInfo,
        index: number
    ): JSX.Element => {
        return (
            <div key={index}>
                <h1>
                    {type === CON.PRO_FIT_LINK_TYPE && (
                        <FormattedMessage
                            id="pro_fit_installer"
                            defaultMessage={'Pro Fit Software Installer'}
                        />
                    )}
                    {type === CON.INSPIRE_LINK_TYPE && (
                        <FormattedMessage
                            id="inspire_installer_x"
                            defaultMessage={'Inspire X Software Installer'}
                        />
                    )}
                </h1>
                <div>
                    {type === CON.PRO_FIT_LINK_TYPE && (
                        <FormattedMessage
                            id="pro_fit_description_x"
                            defaultMessage={CON.PRO_FIT_DESCRIPTION}
                        />
                    )}
                    {type === CON.INSPIRE_LINK_TYPE && (
                        <FormattedMessage
                            id="latest_software_description"
                            defaultMessage={CON.INSPIRE_DESCRIPTION}
                            values={{
                                0: brand === CON.AUDIBEL ? brand : CON.STARKEY,
                            }}
                        />
                    )}
                </div>
                {type === CON.PRO_FIT_LINK_TYPE && renderLinks(links)}
                {type === CON.INSPIRE_LINK_TYPE && renderLinks(links)}
            </div>
        );
    };

    return (
        <>
            {session &&
                isSoftwareInfo &&
                softwareInfo.map((infoObj, index) =>
                    renderSoftwareInfo(infoObj, index)
                )}
        </>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
    };
};
const softwareContainer = connect(mapStateToProps)(SoftwarePage);

export default softwareContainer;
